/* NOOT — UGC reels: muted autoplay when visible, one reel with sound at a time. */
if (!customElements.get('ugc-reels')) {
  customElements.define(
    'ugc-reels',
    class UgcReels extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.videos.forEach((video) => {
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.loop = true;
        });

        const tryPlay = (video) => {
          if (!video.dataset.visible || document.hidden) return;
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        };

        // Play only what is on screen (saves data on mobile), pause the rest
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                video.dataset.visible = '1';
                if (video.preload === 'none') {
                  video.preload = 'auto';
                  video.load();
                }
                tryPlay(video);
              } else {
                delete video.dataset.visible;
                video.pause();
              }
            });
          },
          { threshold: 0.4 }
        );
        this.videos.forEach((video) => {
          video.addEventListener('canplay', () => tryPlay(video));
          this.observer.observe(video);
        });
        // Resume when the shopper comes back to the tab
        this.onVisibility = () => this.videos.forEach((video) => (document.hidden ? video.pause() : tryPlay(video)));
        document.addEventListener('visibilitychange', this.onVisibility);

        // Sound buttons: only one reel can have sound
        this.querySelectorAll('[data-ugc-sound]').forEach((button) => {
          button.addEventListener('click', () => {
            const video = button.closest('.ugc-reel').querySelector('video');
            const turnOn = video.muted;
            this.muteAll();
            if (turnOn) {
              video.muted = false;
              const p = video.play();
              if (p && p.catch) p.catch(() => {});
              button.setAttribute('aria-pressed', 'true');
              button.setAttribute('aria-label', 'Turn sound off');
            }
          });
        });

        // Desktop arrows
        const section = this.closest('.ugc-reels');
        this.nav = section && section.querySelector('[data-ugc-nav]');
        if (this.nav) {
          this.prev = this.nav.querySelector('[data-ugc-prev]');
          this.next = this.nav.querySelector('[data-ugc-next]');
          const step = () => {
            const card = this.querySelector('.ugc-reel');
            return card ? card.getBoundingClientRect().width + 12 : 200;
          };
          this.prev.addEventListener('click', () => this.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
          this.next.addEventListener('click', () => this.scrollBy({ left: step() * 2, behavior: 'smooth' }));
          this.updateNav = () => {
            const overflow = this.scrollWidth > this.clientWidth + 4;
            this.nav.hidden = !overflow;
            this.prev.disabled = this.scrollLeft <= 2;
            this.next.disabled = this.scrollLeft + this.clientWidth >= this.scrollWidth - 2;
          };
          this.addEventListener('scroll', () => this.updateNav(), { passive: true });
          window.addEventListener('resize', this.updateNav);
          this.updateNav();
        }
      }

      muteAll() {
        this.videos.forEach((v) => (v.muted = true));
        this.querySelectorAll('[data-ugc-sound]').forEach((b) => {
          b.setAttribute('aria-pressed', 'false');
          b.setAttribute('aria-label', 'Turn sound on');
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.updateNav) window.removeEventListener('resize', this.updateNav);
      }
    }
  );
}
